import React, { useEffect, useState } from "react";
import Timeline from "../../../component/Timeline/Timeline";
import SectionContainer from "../../../Homepage/SectionContainer";
import BreadCrumb from "../../../component/BreadCrumb/BreadCrumb";
import banner from "../../../assets/kangaroo/AboutBanner.png"
import MilestoneService from "../../../services/MilestoneService";
import PageService from "../../../services/PageService";
import { useLocation, useParams } from "react-router-dom";
import "../About.css"
import { imageBaseApi } from "../../../services/imageBaseApi";

const AboutMilestone = () => {
  const customData = [
    {
      year: 1990,
      title: "Birth of the Internet",
      description: "The World World Web protocol was created.",
    },
    {
      year: 1998,
      title: "Google Founded",
      description: "The search engine revolution begins.",
    },
    {
      year: 2007,
      title: "Mobile Era",
      description: "First iPhone released, ushering in the smartphone age.",
    },
    {
      year: 2012,
      title: "Cloud Computing Boom",
      description: "Rapid adoption of scalable cloud services.",
    },
    {
      year: 2020,
      title: "Remote Work Shift",
      description: "Global pandemic accelerates digital transformation.",
    },
    {
      year: 2024,
      title: "AI Integration",
      description: "Generative AI tools become mainstream.",
    },
  ];

   const location = useLocation();

  console.log(location, "sada")
  const [data, setData] = useState([])
  const [detailData, setDetailData] = useState()
  const fetchDetail = async () => {
    try {
      const response = await PageService.getbySlug(location.pathname.replace(/^\/+/, ""));
      setDetailData(response)
    } catch (error) {
      console.log(error);

    }
  }
  const fetchData = async () => {
    try {
      const response = await MilestoneService.getList();
      setData(response)
    } catch (error) {
      console.log(error);
    }
  }
  useEffect(() => {
    fetchData()
  }, [])

  console.log(data)

  useEffect(() => {
    fetchDetail()
  }, [location])
  return (
    <div>
      <div className='about-hero-banner' style={{ "--banner-img": `url(${imageBaseApi + detailData?.featuredMedia?.url})` }}>
        <SectionContainer className="d-flex align-items-center h-100">
          <BreadCrumb items={[
            { title: "HOME", link: "/" },
            { title: "ABOUT", link: "/about" },
            { title: "MILESTONE" },

          ]} instituition={true} />
          <div className=" page-content text-start h-100 d-flex flex-column justify-content-center">
            <h1 className='font-level-4'>MILESTONES</h1>
          </div>
        </SectionContainer>

      </div>
      <Timeline timelineData={data} />
    </div>
  );
};

export default AboutMilestone;
